import type { MutationHookOptions } from '@apollo/client'
import {
  UpdateTrainingsSettingDocument,
  UpdateTrainingsSettingMutation,
  UpdateTrainingsSettingMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateTrainingsSettingMutation,
  UpdateTrainingsSettingMutationVariables
>

export const useUpdateSetting = (options?: Options) => {
  const [updateSetting, { loading }] = useMutation(UpdateTrainingsSettingDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.updateTrainingsSetting,
  })

  return {
    loading,
    update(variables: UpdateTrainingsSettingMutationVariables) {
      return updateSetting({
        variables,
      })
    },
  }
}
